<template>
    <div class="video-card">
        <div class="thumbnail" @click="() => (isOpen = true)">
            <img :src="getThumbnail(video)" width="620" height="370" />
            <Player class="icon" />
        </div>
        <h3 class="video-title">{{ video.title }}</h3>
    </div>
    <template v-if="isOpen">
        <Teleport to="body">
            <div class="video-card-player-backdrop" @click="() => (isOpen = false)"></div>
            <PrismicEmbed :field="video.video" class="video-card-player" />
        </Teleport>
    </template>
</template>

<script setup lang="ts">
    import {ref} from 'vue';
    import {PrismicEmbed} from '@prismicio/vue';
    import type {VideoListSliceDefaultItem} from '@prismicio-types';
    import Player from './icons/Player.vue';

    defineProps<{video: VideoListSliceDefaultItem}>();
    const isOpen = ref(false);
    function getThumbnail(video: VideoListSliceDefaultItem) {
        if (video.video.embed_url) {
            const videoUrl = new URL(video.video.embed_url);
            const videoId = videoUrl.searchParams.get('v') ?? videoUrl.pathname.split('/').pop() ?? '';
            return `https://img.youtube.com/vi/${videoId}/0.jpg`;
        }

        return '';
    }
</script>

<style lang="scss">
    @use '~/assets/styles/variables' as *;
    .video-card {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        .video-title {
            margin-top: var(--joy-core-spacing-7);
        }
        .thumbnail {
            position: relative;
            cursor: pointer;
            @media (max-width: $mobile-breakpoint) {
                width: 100%;
            }
            img {
                object-fit: cover;
                filter: brightness(0.8);
                position: relative;
                z-index: 1;
                @media (max-width: $mobile-breakpoint) {
                    width: 100%;
                    height: auto;
                }
            }
            .icon {
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                position: absolute;
                z-index: 2;
            }
        }
    }
    .video-card-player-backdrop {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: var(--joy-core-z-index-backdrop);
        background-color: rgba(0, 0, 0, 0.8);
        cursor: pointer;
    }
    .video-card-player {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 80vw;
        height: 45vw; // 16:9
        height: auto;
        z-index: var(--joy-core-z-index-dialog);
        iframe {
            width: 80vw;
            height: 45vw; // 16:9
        }
    }
</style>
